import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className={`font-heading font-bold text-xl whitespace-nowrap ${isScrolled || !isHome ? 'text-foreground-950' : 'text-white'}`}>
              黑料吃瓜网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  isScrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap transition-colors ${
                isScrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-950'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <button
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                isScrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              最新入口
            </button>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${
              isScrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/40 pt-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="block px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="block px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors"
            >
              关于我们
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}